import * as types from './types';

export const refreshProducts = () => ({
  type: types.REFRESH_PRODUCTS
});
